module.exports = __webpack_public_path__ + "img/评价.png";